import { EXCLUDED_CURRENCY, ONLY_CURRENCY } from 'app-config';

export const adapteCurrencies = (currencies: string[]) => {
  if (ONLY_CURRENCY) {
    return currencies.filter((currency) => currency === ONLY_CURRENCY);
  }

  if (EXCLUDED_CURRENCY) {
    return currencies.filter((currency) => !EXCLUDED_CURRENCY?.includes(currency));
  }

  return currencies;
};
